import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IPromise, ITimeoutService} from "angular";
import {LokaltDatalager} from "felles/tjenester/LokaltDatalager";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('TipsKontroller');
const css = require('./tips.scss');

/**
 * Viser tips.
 */
export class TipsKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular.component('wkTips', {
            bindings: {
                forsinketVisning: '@',
                stil: '@',
                noekkel: '@',
                skjulTipshandling: '@'
            },
            controller: TipsKontroller.forInjisering(),
            template: require('./tips.html'),
            transclude: true
        });

        angular
            .service(TipsTjeneste.regNavn, TipsTjeneste.forInjisering());
    }

    static forInjisering() {
        return [regNavn.ng.$timeout, TipsTjeneste.regNavn, TipsKontroller]
    }

    constructor(private $timeout: ITimeoutService, private tipsTjeneste: TipsTjeneste) {
        this.initSkalVises();
    }

    forsinketVisning = false; //settes via bindings/$onChanges
    noekkel: string; //settes via bindings/$onChanges
    stil: 'liten' | 'stor'; //settes via bindings/$onChanges
    skjulTipshandling: 'true' | 'false'; //settes via bindings/$onChanges
    skalVises = false;

    private forsinketVisningTimer:IPromise<any>;

    skjul() {
        this.skalVises = false;
        this.tipsTjeneste.markerSomVist(this.noekkel);
    }

    $onChanges(changes: angular.IOnChangesObject): void {
        dersomChangesInneholder(changes, 'forsinketVisning', forsinketVisning => {
            this.forsinketVisning = forsinketVisning === 'true';
            if (this.forsinketVisning && !this.noekkel) this.initForsinketVisning();
        });
    }

    $onDestroy(): void {
        this.$timeout.cancel(this.forsinketVisningTimer);
    }

    //hjelpemetoder

    private initSkalVises() {
        if (!this.noekkel) {
            this.skalVises = true;
            return;
        }
        this.tipsTjeneste.erVist(this.noekkel).then(vist => {
            if (!vist) this.initForsinketVisning();
        });
    }

    private initForsinketVisning(){
        this.skalVises = false;
        this.$timeout(() => this.skalVises = true, 1000);
    }
}

export class TipsTjeneste {
    static regNavn = "wk.tips.TipsTjeneste";

    static forInjisering() {
        return [LokaltDatalager.regNavn, TipsTjeneste]
    }

    constructor(private datalager: LokaltDatalager) {
    }

    private datalagerNøkkel = "wk.tips.TipsTjeneste";

    erVist(nøkkel: string) {
        return this.hentVisteTips()
            .then(visteTips => visteTips[nøkkel] === true);
    }

    markerSomVist(nøkkel: string) {
        this.hentVisteTips().then(visteTips => {
            visteTips[nøkkel] = true;
            this.lagreVisteTips(visteTips);
        });
    }

    private hentVisteTips() {
        return this.datalager.hentEllerStandardVerdi(this.datalagerNøkkel, {});
    }

    private lagreVisteTips(visteTips) {
        return this.datalager.lagre(this.datalagerNøkkel, visteTips);
    }
}

